// TODO: Move to ENV
import cdAppSettingsProd from "@doitintl/clouddiagrams-frontend/config/settings.prod.js";
import cdAppSettingsDev from "@doitintl/clouddiagrams-frontend/config/settings.dev.js";

const cdAppSettings = process.env.NODE_ENV === "production" ? cdAppSettingsProd : cdAppSettingsDev;

export default cdAppSettings;
